import { NavLink, Outlet, useLocation } from 'react-router-dom';

const PortfolioLayout = () => {
  const location = useLocation();

  const tabs = [
    { name: 'Offering Performance', path: '/dashboard/portfolio/performance', icon: '📈' },
    { name: 'Investments', path: '/dashboard/portfolio/investments', icon: '📊' },
    { name: 'Additional Metrics', path: '/dashboard/portfolio/additional-metrics', icon: '📉' },
  ];

  return (
    <div className="flex gap-6">
      {/* Left Sidebar - Vertical Navigation */}
      <div className="w-64 flex-shrink-0">
        <div className="bg-white rounded-2xl shadow-lg p-4 border border-slate-200 sticky top-4">
          <div className="flex flex-col gap-3">
            {tabs.map((tab) => (
              <NavLink
                key={tab.name}
                to={tab.path}
                className={({ isActive }) =>
                  `px-5 py-4 rounded-xl font-semibold transition-all duration-300 ease-in-out ${
                    isActive
                      ? 'bg-gradient-to-r from-blue-600 to-indigo-600 text-white shadow-lg border-2 border-blue-500 transform translate-x-1'
                      : 'bg-gradient-to-br from-slate-50 to-slate-100 text-slate-700 hover:from-blue-50 hover:to-indigo-50 hover:text-blue-700 hover:shadow-md border-2 border-slate-200 hover:border-blue-300 hover:translate-x-1'
                  }`
                }
              >
                <div className="flex items-center space-x-3">
                  <span className="text-2xl">{tab.icon}</span>
                  <span className="text-sm font-bold tracking-wide">{tab.name}</span>
                </div>
              </NavLink>
            ))}
          </div>
        </div>
      </div>

      {/* Right Content Area */}
      <div className="flex-1 min-w-0">
        <Outlet />
      </div>
    </div>
  );
};

export default PortfolioLayout;
